import { Link } from "react-router";
import { all_routes } from "../../../router/all_routes";

interface Props {
    activeTab: 'CloudStorageSettings' | 'LearningCenter' | 'CourseSetting';
}

const SettingsMenu = ({activeTab}:Props) => {
    const routes = all_routes;


    return (
        <>
            <Link
                to={routes.learningCenter}
                className={`d-inline-flex align-items-center rounded py-2 px-3 ${activeTab === 'LearningCenter' ? 'active' : ''}`}
            >
                <i className="ti ti-arrow-badge-right me-2" />
                Learning Center
            </Link>
            <Link
                to={routes.cloudStorageSettings}
                className={`d-inline-flex align-items-center rounded py-2 px-3 ${activeTab === 'CloudStorageSettings' ? 'active' : ''}`}
            >
                <i className="ti ti-arrow-badge-right me-2" />
                Cloud Storage
            </Link>
            <Link
                to={routes.courseSetting}
                className={`d-inline-flex align-items-center rounded py-2 px-3 ${activeTab === 'CourseSetting' ? 'active' : ''}`}
            >
                <i className="ti ti-arrow-badge-right me-2" />
                Course Setting
            </Link>

        </>
    )
}

export default SettingsMenu;
